const AccountClosureForm =
  "https://d3lgi69rk7563.cloudfront.net/assets/AccountClosure/AccountClosureForm.pdf";

export { AccountClosureForm };
